<template>
  <v-app
    id="inspire"
    class="login"
  >
    <v-snackbar
      v-model="$store.state.snackbar.show"
      top
      right
      :color="$store.state.snackbar.color"
      :timeout="$store.state.snackbar.timeout"
    >
      {{ $store.state.snackbar.message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          dark
          text
          v-bind="attrs"
          top
          right
          @click.native="hideSnackbar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-container
      fluid
      fill-height
      class="login-page"
    >
      <v-layout
        align-center
        justify-center
      >
        <v-card
          width="450"
          height="300"
        >
          <v-card-title
            style="font-size: large"
            class="justify-center"
          >
            Login
          </v-card-title>
          <v-form>
            <v-flex
              pt-2
              pb-1
              offset-xs1
              xs10
            >
              <v-text-field
                id="login_email"
                v-model="login.emailId"
                name="emailID"
                label="EMAIL ID"
                prepend-icon="mdi-email"
                :rules="emailRules"
              />
            </v-flex>
            <v-flex
              pt-1
              pb-1
              offset-xs1
              xs10
            >
              <v-text-field
                id="login_password"
                v-model="login.password"
                type="password"
                name="password"
                label="PASSWORD"
                prepend-icon="mdi-lock"
                :rules="passwordRules"
                @keyup.enter="submitLogin()"
              />
            </v-flex>
            <v-card-actions>
              <v-flex class="text-right pr-7">
                <v-btn
                  id="login"
                  color="success"
                  :loading="submitLoader"
                  @click="submitLogin()"
                >
                  Login
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
          <br>
        </v-card>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      login: {},
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(
            v
          ) ||
          // /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      passwordRules: [(v) => !!v || "Enter password"],
      submitLoader: false
    };
  },
  methods: {
    submitLogin() {
      this.submitLoader = true;
      console.log({ url: this.ADMIN_API_URL, title: this.VUE_APP_TITLE });
      this.$http
        .post(`${this.ADMIN_API_URL}/login`, this.login)
        .then(
          function (data) {
            this.handleSuccess(data.body);
            var loggedInUser = data.body.data;
            this.$store.commit("setLoggedInUser", loggedInUser);
            localStorage.setItem("login_user", JSON.stringify(loggedInUser));
            localStorage.setItem("admin_user_token", loggedInUser.token);

            this.$router.push({ path: "/stores" });
          },
          function (failure) {
            this.handleFailure(failure);
          }
        );
    },
    handleSuccess: function (response) {
      this.submitLoader = false;
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    },
    handleFailure: function (failure) {
      this.submitLoader = false;
      let msg = failure.body.message || "Error";
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    register: function () {
      this.$router.push({ path: "/register" });
    }
  }
};
</script>

<style scoped>
/*login page*/
.login {
  overflow: hidden;
}

.login-page {
  background-image: url("./../../assets/images/finalbg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>